import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation, Link } from "react-router-dom";
import Button from "react-bootstrap/Button";

function RegistrationResponsePage(props) {
  let navigate = useNavigate();
  const location = useLocation();
  const [response, setResponse] = useState("");
  const [imagePath, setImagePath] = useState("");
  useEffect(() => {
    console.log("location: ", location)
    if(location.state.res){
      setImagePath(require("../assets/checked.png"))
      setResponse("You have successfully enrolled.");
    } else {
      setImagePath(require("../assets/cancel.png"))
      setResponse("Something went wrong.");
    }
  }, [location.state.res]);
  return (
    <>
      <div className="alert alert-secondary" role="alert">
        <span style={{ cursor: "pointer" }} onClick={() => navigate("/")}>
          Aquta.io - Data Sciences (M) Sdn. Bhd.
        </span>
      </div>
      <div className="container" style={{ textAlign: "center" }}>
        <img src={imagePath} style={{width: 100, marginBottom: 20}}/>
        <h3 style={{marginBottom: 15}}>{response}</h3>
        <a href="https://portal.aquta.io">
          <Button
            variant="outline-primary"
            className="ml-auto"
            onClick={() => {}}
          >
            Go to Aquta Portal
          </Button>
        </a>
      </div>
    </>
  );
}

export default RegistrationResponsePage;
